import { Link } from "react-router-dom";
import { useSacredAdmin } from "@/hooks/useSacredAdmin";
import { PagesAdmin } from "./PagesAdmin";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export function SacredPagesHub() {
  const { canEditPages } = useSacredAdmin();

  if (!canEditPages) {
    return (
      <div className="min-h-screen py-24 px-4 text-center">
        <p>Sign in as admin, editor, or staff to manage pages.</p>
        <Button asChild className="mt-4">
          <Link to="/admin/sacred">Staff login</Link>
        </Button>
      </div>
    );
  }

  return (
    <div className="min-h-screen py-24 px-4" data-testid="admin-pages-hub">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-wrap gap-2 mb-4">
          <Button variant="ghost" size="sm" asChild>
            <Link to="/admin/sacred">
              <ArrowLeft className="w-4 h-4 mr-1" /> Admin hub
            </Link>
          </Button>
          <Button variant="ghost" size="sm" asChild>
            <Link to="/library">Sacred Library</Link>
          </Button>
        </div>
        <h1 className="font-heading text-3xl mb-2">Universal CMS — Pages</h1>
        <p className="text-muted-foreground mb-8">
          Edit site-wide text: knowledge, sādhana, prayer hall, dashboard copy, and more.
        </p>
        <PagesAdmin />
      </div>
    </div>
  );
}
